// archiveHandlers/aksioma03Handler.js
import axios from 'axios';
import {
    API_URL, NS_VALUE, formatDateTimeWith24, formatValue,
    getAdjustedDateFrom, getAdjustedDateTo, getDatePlusOne, base64ToUint8Array
} from '../archiveUtils';

const PARAM_NAMES = {
    hour: {
        temperatura: ["t1 ", "t2 ", "t3 ", "t4 ", "t5 ", "t6 ", "t7 ", "t8 ", "tx ", "dt1 ", "dt2 ", "dt3 ", "dt4 ", "tokr "],
        davlenie: ["P1 ", "P2 ", "P3 ", "P4 ", "P5 ", "P6 ", "P7 ", "P8 ", "Px ", "dP1 ", "dP2 ", "dP3 ", "dP4 "],
        obemnui_rasxod: ["Go1 ", "Go2 ", "Go3 ", "Go4 ", "Go5 ", "Go6 ", "Go7 ", "Go8 ", "Gox ", "dGo1 ", "dGo2 ", "dGo3 ", "dGo4 "],
        massovui_rasxod: ["Gm1 ", "Gm2 ", "Gm3 ", "Gm4 ", "Gm5 ", "Gm6 ", "Gm7 ", "Gm8 ", "Gmx ", "dGm1 ", "dGm2 ", "dGm3 ", "dGm4 "],
        energi: ["Q1 ", "Q2 ", "Q3 ", "Q4 ", "Q5 ", "Q6 ", "Q7 ", "Q8 ", "Qa ", "Qb ", "Qc ", "Qd "],
    },
    day: {
        temperatura: ["t1с ", "t2с ", "t3с ", "t4с ", "t5с ", "t6с ", "t7с ", "t8с ", "txс ", "dt1с ", "dt2с ", "dt3с ", "dt4с ", "tokrс "],
        davlenie: ["P1с ", "P2с ", "P3с ", "P4с ", "P5с ", "P6с ", "P7с ", "P8с ", "Pxс ", "dP1с ", "dP2с ", "dP3с ", "dP4с "],
        obemnui_rasxod: ["Go1с ", "Go2с ", "Go3с ", "Go4с ", "Go5с ", "Go6с ", "Go7с ", "Go8с ", "Goxс ", "dGo1с ", "dGo2с ", "dGo3с ", "dGo4с "],
        massovui_rasxod: ["Gm1с ", "Gm2с ", "Gm3с ", "Gm4с ", "Gm5с ", "Gm6с ", "Gm7с ", "Gm8с ", "Gmxс ", "dGm1с ", "dGm2с ", "dGm3с ", "dGm4с "],
        energi: ["Q1с ", "Q2с ", "Q3с ", "Q4с ", "Q5с ", "Q6с ", "Q7с ", "Q8с ", "Qaс ", "Qbс ", "Qcс ", "Qdс "],
    },
    month: {
        temperatura: ["t1м ", "t2м ", "t3м ", "t4м ", "t5м ", "t6м ", "t7м ", "t8м ", "txм ", "dt1м ", "dt2м ", "dt3м ", "dt4м ", "tokrм "],
        davlenie: ["P1м ", "P2м ", "P3м ", "P4м ", "P5м ", "P6м ", "P7м ", "P8м ", "Pxм ", "dP1м ", "dP2м ", "dP3м ", "dP4м "],
        obemnui_rasxod: ["Go1м ", "Go2м ", "Go3м ", "Go4м ", "Go5м ", "Go6м ", "Go7м ", "Go8м ", "Goxм ", "dGo1м ", "dGo2м ", "dGo3м ", "dGo4м "],
        massovui_rasxod: ["Gm1м ", "Gm2м ", "Gm3м ", "Gm4м ", "Gm5м ", "Gm6м ", "Gm7м ", "Gm8м ", "Gmxм ", "dGm1м ", "dGm2м ", "dGm3м ", "dGm4м "],
        energi: ["Q1м ", "Q2м ", "Q3м ", "Q4м ", "Q5м ", "Q6м ", "Q7м ", "Q8м ", "Qaм ", "Qbм ", "Qcм ", "Qdм "],
    },
    integral: {
        volume: ["V1 ", "V2 ", "V3 ", "V4 ", "V5 ", "V6 ", "V7 ", "V8 ", "Vx ", "dV1 ", "dV2 ", "dV3 ", "dV4 "],
        massa: ["M1 ", "M2 ", "M3 ", "M4 ", "M5 ", "M6 ", "M7 ", "M8 ", "Mx ", "dM1 ", "dM2 ", "dM3 ", "dM4 "],
        energi: ["Q1 ", "Q2 ", "Q3 ", "Q4 ", "Q5 ", "Q6 ", "Q7 ", "Q8 ", "Qa ", "Qb ", "Qc ", "Qd "],
    }
};

const getIndexFromKey = (key) => parseInt(key.substring(key.lastIndexOf('_') + 1));

const buildTableColumns = (config, archiveType) => {
    const columns = [];
    const paramNames = PARAM_NAMES[archiveType];
    const isIntegral = archiveType === 'integral';
    for (let i = 0; i < config.length; i++) {
        const conf = config[i];
        if (conf === 0xA0) {
            columns.push({ key: 'datetime', name: 'Дата', type: 'datetime' });
        } else if (conf === 0xA1) {
            columns.push({ key: 'timeWork', name: 'ВН, ч', type: 'number', unit: 'час' });
        } else if (conf === 0xA2) {
            columns.push({ key: 'timeNotWork', name: 'ВП, ч', type: 'number', unit: 'час' });
        } else if (conf >= 0x10 && conf < 0x20 && !isIntegral) {
            const idx = conf - 0x10;
            const name = paramNames.temperatura[idx] || `t${idx + 1}`;
            columns.push({ key: `temperatura_${idx}`, name: `${name.trim()}, °C`, type: 'number', unit: '°C' });
        } else if (conf >= 0x20 && conf < 0x30 && !isIntegral) {
            const idx = conf - 0x20;
            const name = paramNames.davlenie[idx] || `P${idx + 1}`;
            columns.push({ key: `davlenie_${idx}`, name: `${name.trim()}, МПа`, type: 'number', unit: 'МПа' });
        } else if (conf >= 0x30 && conf < 0x40) {
            const idx = conf - 0x30;
            if (isIntegral) {
                const name = paramNames.volume[idx] || `V${idx + 1}`;
                columns.push({ key: `volume_${idx}`, name: `${name.trim()}, м³`, type: 'number', unit: 'м³' });
            } else {
                const name = paramNames.obemnui_rasxod[idx] || `Go${idx + 1}`;
                columns.push({ key: `obemnui_rasxod_${idx}`, name: `${name.trim()}, м³`, type: 'number', unit: 'м³' });
            }
        } else if (conf >= 0x40 && conf < 0x50) {
            const idx = conf - 0x40;
            if (isIntegral) {
                const name = paramNames.massa[idx] || `M${idx + 1}`;
                columns.push({ key: `massa_${idx}`, name: `${name.trim()}, т`, type: 'number', unit: 'т' });
            } else {
                const name = paramNames.massovui_rasxod[idx] || `Gm${idx + 1}`;
                columns.push({ key: `massovui_rasxod_${idx}`, name: `${name.trim()}, т`, type: 'number', unit: 'т' });
            }
        } else if (conf >= 0x50 && conf <= 0x60) {
            const idx = conf - 0x50;
            const name = paramNames.energi[idx] || `Q${idx + 1}`;
            columns.push({ key: `energi_${idx}`, name: `${name.trim()}, Гкал`, type: 'number', unit: 'Гкал' });
        }
    }
    return columns;
};

const getCellValue = (recordData, columnKey, podSystemIndex) => {
    if (columnKey === 'datetime') return formatDateTimeWith24(recordData.onDateTime);
    if (columnKey === 'timeWork') return recordData.timeWork?.[podSystemIndex];
    if (columnKey === 'timeNotWork') return recordData.timeNotWork?.[podSystemIndex];
    if (columnKey.startsWith('temperatura_')) return recordData.temperatura?.[getIndexFromKey(columnKey)];
    if (columnKey.startsWith('davlenie_')) return recordData.davlenie?.[getIndexFromKey(columnKey)];
    if (columnKey.startsWith('obemnui_rasxod_')) return recordData.obemnui_rasxod?.[getIndexFromKey(columnKey)];
    if (columnKey.startsWith('massovui_rasxod_')) return recordData.massovui_rasxod?.[getIndexFromKey(columnKey)];
    if (columnKey.startsWith('volume_')) return recordData.volume?.[getIndexFromKey(columnKey)];
    if (columnKey.startsWith('massa_')) return recordData.massa?.[getIndexFromKey(columnKey)];
    if (columnKey.startsWith('energi_')) return recordData.energi?.[getIndexFromKey(columnKey)];
    return null;
};

const getAccumulatedValue = (accumData, colKey, podSystemIndex) => {
    if (!accumData) return null;
    if (colKey === 'timeWork') return accumData.timeWork?.[podSystemIndex];
    if (colKey === 'timeNotWork') return accumData.timeNotWork?.[podSystemIndex];
    if (colKey.startsWith('volume_')) return accumData.volume?.[getIndexFromKey(colKey)];
    if (colKey.startsWith('massa_')) return accumData.massa?.[getIndexFromKey(colKey)];
    if (colKey.startsWith('energi_')) return accumData.energi?.[getIndexFromKey(colKey)];
    if (colKey.startsWith('obemnui_rasxod_')) return accumData.volume?.[getIndexFromKey(colKey)];
    if (colKey.startsWith('massovui_rasxod_')) return accumData.massa?.[getIndexFromKey(colKey)];
    return null;
};

const buildAccumColumns = (columns) => {
    return columns
        .filter(col => !col.key.startsWith('temperatura_') && !col.key.startsWith('davlenie_'))
        .map(col => {
            if (col.key.startsWith('obemnui_rasxod_')) {
                const idx = getIndexFromKey(col.key);
                return { ...col, key: `volume_${idx}`, name: `${PARAM_NAMES.integral.volume[idx]?.trim() || `V${idx + 1}`}, м³` };
            }
            if (col.key.startsWith('massovui_rasxod_')) {
                const idx = getIndexFromKey(col.key);
                return { ...col, key: `massa_${idx}`, name: `${PARAM_NAMES.integral.massa[idx]?.trim() || `M${idx + 1}`}, т` };
            }
            if (col.key.startsWith('energi_')) {
                const idx = getIndexFromKey(col.key);
                return { ...col, name: `${PARAM_NAMES.integral.energi[idx]?.trim() || `Q${idx + 1}`}, Гкал` };
            }
            return col;
        });
};

// === Основной экспорт: генерация отчетов для Аксиома-03 ===
export const generateAksioma03Reports = async (devName, params, headers, deviceFromList) => {
    const reports = [];

    const infoRes = await axios.get(`${API_URL}/api/devices/aksioma03/${devName}/info`, { headers });
    const deviceInfo = infoRes.data;

    const adjustedDateFrom = getAdjustedDateFrom(params.dateFrom, params.archiveType);
    const adjustedDateTo = getAdjustedDateTo(params.dateTo, params.archiveType);

    const archiveRes = await axios.get(`${API_URL}/api/devices/aksioma03/${devName}/archive`, {
        params: { type: params.archiveType, from: adjustedDateFrom, to: adjustedDateTo }, headers
    });
    const { records, podSystems } = archiveRes.data;

    if (!podSystems || podSystems.length === 0) return reports;

    for (let psIdx = 0; psIdx < podSystems.length; psIdx++) {
        const ps = podSystems[psIdx];
        const configRaw = ps.config;
        const config = typeof configRaw === 'string' ? base64ToUint8Array(configRaw) : (configRaw || []);
        const columns = buildTableColumns(config, params.archiveType);

        const sortedRecords = [...records].sort((a, b) => {
            const dateA = new Date(a.data.onDateTime || 0).getTime();
            const dateB = new Date(b.data.onDateTime || 0).getTime();
            return dateA - dateB;
        });

        const processedRecords = sortedRecords.map(rec => {
            const row = {};
            columns.forEach(col => {
                row[col.key] = getCellValue(rec.data, col.key, psIdx);
            });
            return row;
        });

        const totals = {};
        const sums = {};
        const counts = {};

        processedRecords.forEach(r => {
            columns.forEach(col => {
                if (col.key === 'datetime') return;
                const val = r[col.key];
                if (val === NS_VALUE || val == null || isNaN(parseFloat(val))) return;
                const num = parseFloat(val);
                if (!totals[col.key]) totals[col.key] = 0;
                if (!sums[col.key]) sums[col.key] = 0;
                if (!counts[col.key]) counts[col.key] = 0;
                if (col.key.startsWith('temperatura_') || col.key.startsWith('davlenie_')) {
                    sums[col.key] += num;
                    counts[col.key]++;
                } else {
                    totals[col.key] += num;
                }
            });
        });

        const averages = {};
        Object.keys(sums).forEach(key => {
            averages[key] = counts[key] > 0 ? sums[key] / counts[key] : NS_VALUE;
        });

        let startAccum = null, endAccum = null;
        if (params.archiveType !== 'integral') {
            try {
                const startRes = await axios.get(`${API_URL}/api/devices/aksioma03/${devName}/archive`, {
                    params: { type: 'integral', from: params.dateFrom, to: params.dateFrom }, headers
                });
                startAccum = startRes.data?.records?.[0]?.data || null;
            } catch (e) { }

            const dateToPlusOne = getDatePlusOne(params.dateTo).toISOString().split('T')[0];
            try {
                const endRes = await axios.get(`${API_URL}/api/devices/aksioma03/${devName}/archive`, {
                    params: { type: 'integral', from: dateToPlusOne, to: dateToPlusOne }, headers
                });
                endAccum = endRes.data?.records?.[0]?.data || null;
            } catch (e) { }
        }

        reports.push({
            deviceInfo,
            deviceFromList,
            deviceName: devName,
            deviceType: 'aksioma03',
            podSystemName: ps.name || `Подсистема ${psIdx + 1}`,
            podSystemIndex: psIdx,
            columns,
            records: processedRecords,
            totals,
            averages,
            startAccumulated: startAccum,
            endAccumulated: endAccum,
            archiveType: params.archiveType
        });
    }

    return reports;
};

export { buildAccumColumns, getAccumulatedValue, getCellValue, buildTableColumns, PARAM_NAMES };